export default __webpack_public_path__ + "static/media/demo-3.ea85561c.png";